export default "__VITE_ASSET__CcyJoKS5__"